import { RequestContext, ResponseContext } from "./generated/runtime";
import {
  ActionsAppsApi,
  ArtifactsApi,
  WidgetActionsApi,
  AudioApi,
  AuthApi,
  ChatApi,
  ChatLogsApi,
  Configuration,
  FileApi,
  PropertyApi,
  SubscriptionApi,
  SubscriptionFlowApi,
  SubscriptionPlansApi,
  UsersApi,
} from "./generated";
import { toast } from "@shared/services/toast";
import { getApiRootUrl } from "@shared/utils/api-root-url";

async function preMiddleware(context: RequestContext) {
  context.init.credentials = "include";
  return context;
}

function getPostMiddleware() {
  return async (context: ResponseContext) => {
    const { response, init } = context;
    const headers = init.headers as Record<string, string>;
    if (response.status === 401 && headers.Authorization) {
      toast.error("Your session has expired. Please sign in again.", {
        toastId: "session-expired",
      });
      window.location.reload();
    }
    return response;
  };
}

function getConfig() {
  return new Configuration({
    basePath: getApiRootUrl(),
  });
}

// CHAT API
export const getChatApiClient = (): ChatApi => {
  return new ChatApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};
export const getChatApiClientConfig = () => getConfig();

// FILE API
export const getFileApiClient = (): FileApi => {
  return new FileApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// AUDIO API
export const getAudioApiClient = (): AudioApi => {
  return new AudioApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// AUTH API
export const getAuthApiClient = () => {
  return new AuthApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};
export const getAuthApiClientConfig = () => getConfig();
export const getAuthLogoutUrl = () => `${getConfig().basePath}/auth/logout`;

// APPS API
export const getActionsAppsApiClient = () => {
  return new ActionsAppsApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};
export const getActionsAppsClientConfig = () => getConfig();

// SUBSCRIPTION FLOW API
export const getSubscriptionFlowApiClient = () => {
  return new SubscriptionFlowApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// SUBSCRIPTION API
export const getSubscriptionApiClient = () => {
  return new SubscriptionApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// USERS API
export const getUsersApiClient = () => {
  return new UsersApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// SUBSCRIPTION PLANS API
export const getSubscriptionPlansApiClient = () => {
  return new SubscriptionPlansApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// CHAT LOGS API
export const getChatLogsApiClient = () => {
  return new ChatLogsApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// ARTIFACTS API
export const getArtifactsApiClient = () => {
  return new ArtifactsApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// WIDGET ACTIONS API
export const getWidgetActionsApiClient = () => {
  return new WidgetActionsApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};

// PROPERTY API
export const getPropertyApiClient = () => {
  return new PropertyApi(getConfig())
    .withPreMiddleware(preMiddleware)
    .withPostMiddleware(getPostMiddleware());
};
